module.exports = __webpack_public_path__ + "static/media/order_blu_bar_active.36d0fa51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_blu_bar_active.png
// module id = 1663
// module chunks = 0